import React, { FunctionComponent } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Provider as ReduxProvider } from 'react-redux';
import { FixedContentContainerProvider } from 'record-it-components/fixedContent/FixedContentContainerProvider/FixedContentContainerProvider';
import { FixedButtonContainerProvider } from 'record-it-components/button/FixedButtonContainerProvider/FixedButtonContainerProvider';
import { NotificationManagerProvider } from 'record-it-components/notification/NotificationManagerProvider/NotificationManagerProvider';
import { NotificationContainer } from 'record-it-components/notification/NotificationContainer/NotificationContainer';
import { GlobalConfirmDeleteDialogProvider } from 'record-it-components/modal/GlobalConfirmDeleteDialogProvider/GlobalConfirmDeleteDialogProvider';
import { BreadcrumbsProvider } from 'record-it-components/pageLayout/BreadcrumbsProvider/BreadcrumbsProvider';
import { GeolocationManagerContextProvider } from 'record-it-components/location/GeolocationManagerContextProvider/GeolocationManagerContextProvider';
import { AppRoutes } from './AppRoutes';
import { AppAuthenticationContextProvider } from './AppAuthenticationContextProvider';
import { AppEntityManagerContextProvider } from './AppEntityManagerContextProvider';
import { AppSocketContextProvider } from './AppSocketContextProvider';
import { AppStopwatchManagerContextProvider } from './AppStopwatchManagerContextProvider';
import { AppCurrentUserContextProvider } from './AppCurrentUserContextProvider';
import { AppBaseSetup } from './AppBaseSetup';
import { AppPageLoadingOverlayContextProvider } from './AppPageLoadingOverlayContextProvider';
import { AppActualizationOverlayController } from './AppActualizationOverlayController';
import { store } from '../store/store';
import { AutoReauthenticateDialog } from '../components/authentication/AutoReauthenticateDialog/AutoReauthenticateDialog';

export const App: FunctionComponent<Record<string, never>> = () => {
  return (
    <ReduxProvider store={store}>
      <AppPageLoadingOverlayContextProvider>
        <AppBaseSetup>
          <GeolocationManagerContextProvider>
            <DndProvider backend={HTML5Backend}>
              <FixedContentContainerProvider>
                <FixedButtonContainerProvider>
                  <BreadcrumbsProvider>
                    <GlobalConfirmDeleteDialogProvider>
                      <NotificationManagerProvider>
                        <AppAuthenticationContextProvider>
                          <AppEntityManagerContextProvider>
                            <AppCurrentUserContextProvider>
                              <AppStopwatchManagerContextProvider>
                                <AppSocketContextProvider>
                                  <AppRoutes></AppRoutes>
                                  <AppActualizationOverlayController>
                                    <AutoReauthenticateDialog></AutoReauthenticateDialog>
                                  </AppActualizationOverlayController>
                                </AppSocketContextProvider>
                              </AppStopwatchManagerContextProvider>
                            </AppCurrentUserContextProvider>
                          </AppEntityManagerContextProvider>
                        </AppAuthenticationContextProvider>
                        <NotificationContainer></NotificationContainer>
                      </NotificationManagerProvider>
                    </GlobalConfirmDeleteDialogProvider>
                  </BreadcrumbsProvider>
                </FixedButtonContainerProvider>
              </FixedContentContainerProvider>
            </DndProvider>
          </GeolocationManagerContextProvider>
        </AppBaseSetup>
      </AppPageLoadingOverlayContextProvider>
    </ReduxProvider>
  );
};
